export const SUPPORTED_FIAT_CURRENCIES = [
  { code: 'USD', name: 'US Dollar' },
  { code: 'AUD', name: 'Australian Dollar' },
  { code: 'CHF', name: 'Swiss Franc', locale: 'en-CH' },
  { code: 'CNY', name: 'Chinese Yuan' },
  { code: 'EUR', name: 'Euro' },
  { code: 'GBP', name: 'British Pound' },
  { code: 'HKD', name: 'Hong Kong Dollar' },
  { code: 'INR', name: 'Indian Rupee', locale: 'en-IN' },
  { code: 'JPY', name: 'Japanese Yen' },
  { code: 'KRW', name: 'South Korean Won' },
  { code: 'SEK', name: 'Swedish Krona' },
  { code: 'SGD', name: 'Singapore Dollar' },
  { code: 'THB', name: 'Thai Baht' },
] as const;

export type FiatCurrencyCode = (typeof SUPPORTED_FIAT_CURRENCIES)[number]['code'];

/**
 * Locale used to format amounts of the given currency. English-region locales
 * only: currencies whose digit grouping matches en-US conventions omit the
 * `locale` field and fall back to en-US.
 */
export const getFiatLocale = (currency: string): string => {
  const entry = SUPPORTED_FIAT_CURRENCIES.find((c) => c.code === currency);
  return entry && 'locale' in entry ? entry.locale : 'en-US';
};

export const DEFAULT_FIAT_CURRENCY: FiatCurrencyCode = 'USD';

/** FX rate refresh interval: 5 minutes */
export const FX_RATE_REFRESH_INTERVAL = 5 * 60 * 1000;

/** Lowercase currency codes for CoinGecko vs_currencies param */
export const COINGECKO_VS_CURRENCIES = SUPPORTED_FIAT_CURRENCIES.map((c) =>
  c.code.toLowerCase(),
).join(',');
